import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const publishMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/myme/:mymeId/publish'
};

export const duplicateMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/myme/:mymeId/duplicate'
};

export const unpublishMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/myme/:mymeId/unpublish'
};

export const deleteMymeByAuthorAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/myme/:mymeId/author'
};

export const getOwnLocationBasedMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getOwnLocationBasedMymesAPI'],
  path: '/myme/author/created'
};

export const getOwnTimeBasedMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getOwnTimeBasedMymesAPI'],
  path: '/myme/author/created'
};

export const getOwnCourseMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getOwnCourseMymesAPI'],
  path: '/myme/author/created'
};
